import React from 'react';

import CCSIconMessage from '@ey/canvascoreservices/IconMessage';

const IconMessage = ({...rest}) => <CCSIconMessage {...rest} />;

export default IconMessage;
